export default __webpack_public_path__ + "static/media/FD_Bank.34707ca7.svg";